import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M5467 7203 c-29 -8 -64 -42 -78 -74 -6 -16 -21 -31 -33 -34 -11 -2
-48 -9 -81 -16 -267 -51 -535 -272 -668 -552 -39 -82 -86 -216 -101 -288 -3
-15 -22 -39 -43 -54 -61 -45 -83 -72 -114 -140 l-29 -65 -93 0 c-50 0 -97 -4
-103 -8 -6 -4 -16 -20 -22 -37 -10 -30 -10 -30 -11 -4 -3 86 -120 101 -147 19
-31 -95 70 -163 131 -87 23 29 27 30 36 15 8 -15 25 -18 87 -19 99 -1 124 -9
132 -39 22 -80 86 -165 147 -193 23 -10 29 -22 64 -137 40 -130 123 -281 214
-389 146 -173 344 -291 550 -327 44 -8 82 -19 84 -25 2 -6 17 -24 34 -40 52
-50 150 -36 196 30 16 22 31 30 70 35 100 13 240 71 356 149 79 52 197 173
265 272 60 87 143 268 162 354 9 43 18 57 42 72 81 48 131 108 158 189 l15 45
108 3 c60 1 115 8 122 14 7 6 13 27 13 48 0 21 -6 42 -13 48 -7 6 -62 13 -122
14 l-108 3 -33 64 c-37 72 -83 124 -125 142 -22 8 -31 22 -39 53 -24 91 -63
204 -95 273 -139 298 -423 526 -709 568 -41 6 -49 12 -65 44 -11 20 -28 44
-39 54 -21 19 -82 30 -115 20z m-42 -263 c49 -39 105 -41 157 -5 46 31 71 31
166 -1 269 -90 477 -301 587 -598 42 -113 42 -112 -14 -140 -60 -31 -122 -101
-145 -167 l-18 -49 -97 0 c-109 0 -121 -6 -121 -60 0 -54 12 -60 121 -60 l97
0 7 -27 c21 -87 91 -176 158 -204 26 -11 29 -16 24 -49 -6 -49 -72 -188 -130
-276 -45 -68 -129 -162 -192 -214 -86 -71 -218 -139 -327 -167 l-67 -17 -28
26 c-37 34 -66 48 -100 48 -32 0 -91 -33 -99 -55 -18 -47 -254 36 -394 138
-120 89 -238 236 -304 380 -31 68 -66 153 -66 161 0 2 19 13 43 24 59 28 108
79 136 143 13 30 27 61 31 69 5 12 31 16 115 18 60 1 115 8 122 14 16 13 17
80 1 96 -8 8 -51 12 -125 12 -99 0 -114 2 -120 18 -34 101 -99 179 -169 202
-18 6 -34 17 -37 24 -8 19 40 150 90 246 128 248 332 416 588 485 68 19 67 19
110 -15z m-798 -881 c15 -5 40 -22 55 -36 25 -24 27 -31 22 -78 -4 -32 -2 -60
5 -74 10 -18 9 -28 -6 -53 -44 -76 -142 -87 -200 -24 -38 41 -41 61 -13 76 25
13 27 61 3 101 -16 28 -16 29 7 54 20 21 59 40 92 44 4 1 19 -4 35 -10z m1830
0 c15 -5 40 -22 55 -36 25 -24 27 -31 22 -78 -4 -32 -2 -60 5 -74 10 -18 8
-28 -10 -58 -45 -73 -142 -81 -199 -17 -35 41 -37 55 -10 72 25 15 28 83 5
102 -8 7 -15 18 -15 24 0 25 69 73 107 75 6 1 24 -4 40 -10z"/>
<path d="M5374 6700 c-132 -19 -306 -94 -422 -184 -74 -56 -132 -116 -132
-136 0 -8 29 -47 64 -85 l64 -70 44 40 c23 22 45 43 48 46 14 15 131 88 173
107 73 34 203 62 288 62 174 0 364 -81 502 -214 26 -25 51 -46 56 -46 5 0 25
19 44 43 20 23 47 55 61 71 14 16 26 32 26 35 0 14 -99 109 -164 157 -185 139
-434 205 -652 174z"/>
<path d="M5342 6340 c-40 -11 -100 -34 -133 -51 -70 -38 -177 -127 -178 -149
-1 -17 105 -140 120 -140 5 0 32 18 59 39 28 22 76 52 107 68 54 26 67 28 178
28 117 0 122 -1 188 -34 38 -19 91 -55 119 -80 l50 -45 34 40 c19 21 48 56 65
77 l31 37 -44 44 c-58 58 -168 128 -248 156 -92 33 -247 37 -348 10z"/>
<path d="M5391 6011 c-61 -23 -93 -42 -135 -82 l-29 -27 59 -70 c32 -39 64
-71 69 -71 6 -1 32 10 59 24 27 14 63 25 80 25 34 0 109 -31 120 -49 15 -24
43 -8 99 55 31 36 57 69 57 74 0 18 -66 72 -122 101 -79 40 -180 48 -257 20z"/>
<path d="M5469 5689 c-16 -6 -33 -25 -44 -49 -16 -35 -17 -47 -6 -93 11 -47
10 -59 -12 -127 -14 -41 -30 -94 -36 -117 -12 -45 -26 -55 -35 -25 -20 71 -70
233 -81 262 -12 33 -15 35 -61 35 -38 0 -49 -3 -47 -15 3 -25 24 -104 33 -125
5 -11 23 -67 40 -125 17 -58 36 -120 41 -137 l11 -33 78 0 78 0 25 83 c14 45
31 101 38 125 7 23 17 41 23 39 6 -2 28 -58 49 -125 l38 -122 64 0 c74 0 95 6
95 28 0 9 11 50 25 92 55 170 94 304 89 312 -3 4 -25 8 -49 8 -53 0 -49 6
-100 -167 -22 -73 -44 -133 -51 -133 -6 0 -27 55 -47 123 -28 97 -35 133 -30
173 5 46 3 54 -23 82 -33 35 -67 45 -105 31z"/>
<path d="M7009 6005 c-74 -40 -45 -165 37 -165 43 0 64 30 64 91 0 39 -5 51
-26 68 -31 24 -40 25 -75 6z"/>
<path d="M3796 4458 c4 -13 10 -36 14 -53 13 -54 67 -250 116 -422 2 -8 21
-13 49 -13 38 0 47 4 55 23 16 40 53 161 70 230 9 37 20 69 24 70 4 1 23 -50
42 -113 66 -226 55 -205 108 -208 40 -3 47 0 55 20 13 33 131 462 131 476 0 8
-20 12 -58 12 l-58 0 -33 -142 c-45 -199 -42 -192 -58 -128 -7 30 -28 104 -45
163 l-32 108 -50 -3 -50 -3 -23 -80 c-13 -44 -32 -111 -42 -148 -18 -71 -34
-90 -39 -47 -2 14 -17 82 -33 153 l-31 127 -60 0 c-57 0 -59 -1 -52 -22z"/>
<path d="M4512 4287 c3 -187 4 -195 28 -230 36 -54 100 -82 180 -81 77 2 128
22 163 64 39 46 47 90 47 273 l0 167 -59 0 -59 0 -4 -184 c-3 -162 -5 -186
-22 -204 -40 -45 -125 -31 -146 24 -6 14 -10 102 -10 195 l0 169 -61 0 -61 0
4 -193z"/>
<path d="M5020 4225 l0 -256 58 3 57 3 -1 148 c0 81 3 147 7 147 5 0 14 -10
20 -22 7 -13 50 -80 97 -150 l84 -128 49 0 49 0 0 255 0 255 -61 0 -62 0 7
-150 c4 -82 3 -150 -1 -149 -4 0 -52 67 -105 150 l-97 149 -51 0 -50 0 0 -255z"/>
<path d="M5550 4225 l0 -256 148 3 147 3 0 40 0 40 -87 3 -88 3 0 209 0 210
-60 0 -60 0 0 -255z"/>
<path d="M5890 4225 l0 -255 60 0 60 0 0 255 0 255 -60 0 -60 0 0 -255z"/>
<path d="M6120 4225 l0 -255 62 0 61 0 -6 150 c-5 147 0 174 24 128 6 -13 50
-81 96 -151 l84 -128 47 3 47 3 3 253 2 252 -61 0 -62 0 5 -150 c3 -82 3 -150
-1 -150 -3 1 -50 68 -103 150 l-97 150 -51 0 -50 0 0 -255z"/>
<path d="M6642 4228 l3 -253 60 0 60 0 3 253 2 252 -65 0 -65 0 2 -252z"/>
<path d="M6900 4413 c-18 -53 -33 -79 -71 -116 l-49 -47 87 -140 87 -140 63 0
c35 0 63 2 63 5 0 3 -36 59 -80 126 -44 66 -80 128 -80 137 0 9 15 31 33 49
20 19 42 57 55 95 33 94 32 98 -32 98 l-54 0 -22 -67z"/>
<path d="M4302 3588 l3 -173 80 1 c88 1 130 16 164 60 43 54 36 180 -12 233
-34 37 -79 51 -162 51 l-75 0 2 -172z m155 98 c24 -21 28 -32 31 -92 3 -59 1
-73 -18 -96 -16 -21 -30 -28 -56 -28 l-34 0 0 113 c0 63 3 117 7 120 13 14 43
6 70 -17z"/>
<path d="M4709 3733 c-94 -234 -120 -313 -105 -319 31 -12 59 1 69 31 16 48
26 55 83 55 50 0 55 -2 64 -27 17 -49 26 -58 59 -61 39 -4 39 0 0 108 -17 47
-43 120 -57 162 l-27 78 -38 0 c-32 0 -39 -4 -48 -27z m80 -155 c1 -22 -9 -27
-43 -21 -24 5 -27 9 -23 32 3 14 11 40 17 56 l12 30 18 -40 c10 -22 19 -48 19
-57z"/>
<path d="M4910 3735 c0 -21 5 -25 28 -25 49 0 51 -7 54 -155 l3 -140 35 0 35
0 5 145 5 145 40 5 c32 4 41 9 43 28 3 22 2 22 -122 22 l-126 0 0 -25z"/>
<path d="M5283 3743 c-6 -19 -45 -124 -68 -183 -7 -19 -22 -57 -33 -85 -11
-27 -18 -53 -16 -57 3 -5 19 -8 35 -8 26 0 32 6 49 45 l19 45 56 0 56 0 19
-45 c16 -38 24 -45 48 -45 16 0 31 3 34 6 4 3 -7 42 -24 87 -16 45 -44 121
-61 170 l-32 87 -38 0 c-27 0 -39 -5 -44 -17z m67 -128 c14 -51 15 -50 -23
-59 -33 -8 -44 11 -29 52 6 15 13 35 16 45 9 27 22 13 36 -38z"/>
<path d="M5672 3588 l3 -173 35 0 35 0 5 75 5 75 60 0 60 0 5 -75 5 -75 35 0
35 0 3 173 2 172 -39 0 -40 0 -3 -67 -3 -68 -39 -3 c-22 -2 -50 -1 -63 2 -21
6 -23 12 -23 71 l0 65 -40 0 -40 0 2 -172z"/>
<path d="M6030 3643 c0 -176 32 -226 145 -226 58 0 96 17 123 56 20 30 22 45
22 160 l0 127 -40 0 -40 0 0 -123 c0 -133 -6 -151 -52 -162 -21 -5 -33 -1 -52
19 -25 24 -26 30 -26 146 l0 120 -40 0 -40 0 0 -117z"/>
<path d="M6382 3588 l3 -173 80 1 c54 1 91 6 113 18 60 31 65 99 11 139 l-29
21 24 23 c34 32 40 58 20 91 -22 38 -64 52 -152 52 l-72 0 2 -172z m137 108
c28 -34 -5 -97 -43 -83 -16 6 -24 76 -9 90 11 12 40 8 52 -7z m9 -148 c7 -7
12 -25 12 -40 0 -22 -6 -31 -27 -39 -41 -15 -53 -5 -53 46 0 43 1 45 28 45 15
0 33 -5 40 -12z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
